const StarRemoveIcon = ({ 
  size = 'large',
  ...props 
}: {
  size?: 'small' | 'medium' | 'large';
}) => {
  return (
    <svg
			{...props}
			width={size === 'small' ? '16' : size === 'medium' ? '20' : '24'}
			height={size === 'small' ? '16' : size === 'medium' ? '20' : '24'} 
			viewBox="0 0 24 24" 
			fill="none" 
			xmlns="http://www.w3.org/2000/svg">
			<path d="M17.5 17.5L18.255 20.8359C18.3382 21.2544 17.8928 21.5787 17.5205 21.3703L12.2451 18.4166C12.0934 18.3317 11.9091 18.3321 11.7573 18.417L6.48144 21.3695C6.10913 21.5779 5.66294 21.2544 5.74609 20.8359L6.92414 14.9066C6.95803 14.7361 6.90134 14.5599 6.77367 14.4419L2.33496 10.3368C2.02171 10.0471 2.19187 9.52339 2.61557 9.47316L8.61914 8.76107M18 13.5L21.6659 10.3369C21.9791 10.0472 21.8094 9.52339 21.3857 9.47316L15.3818 8.76124C15.2092 8.74077 15.0601 8.63204 14.9873 8.47413L12.4551 2.98439C12.2764 2.59695 11.7256 2.59703 11.5469 2.98446L10.2808 5.72936" stroke="#7A7A7A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M4 4L8 8L12 12L20 20" stroke="#7A7A7A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>

  );
};

export default StarRemoveIcon;
